const planPriceFormat=new Intl.NumberFormat('ko-KR',{useGrouping:false,maximumFractionDigits:0});

// Display only. Billing continues to use the original numeric amount.
export const formatBitePlanPrice=(amount:number)=>planPriceFormat.format(amount);
